import { render, staticRenderFns } from "./declareSite.vue?vue&type=template&id=66830330"
import script from "./declareSite.vue?vue&type=script&lang=js"
export * from "./declareSite.vue?vue&type=script&lang=js"
import style0 from "./declareSite.vue?vue&type=style&index=0&id=66830330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports